export default __webpack_public_path__ + "static/media/add-team-modal-BG.482dc2ee.png";